export default [
  {
    path: '/employees/time-tracking',
    name: 'timeTracking',
    meta: {modelName: 'Fichage', needGuard: true, modules: ['auth_system']},
    component: () => import( '@/modules/users/userTimeTracking/UserTimeTracking.vue'),
  },
];
